import classNames from "classnames"
import { FC } from "react"
import styles from "../../styles/icons.module.scss"

export const ReadyForReplicationIcon: FC<ISvgProps> = (props) => {
    return (
        <svg className={classNames(styles.svg, props.className)} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6C4 4.89543 7.58172 4 12 4C16.4183 4 20 4.89543 20 6C20 7.10457 16.4183 8 12 8C7.58172 8 4 7.10457 4 6Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 6V11C4 12.1046 7.58172 13 12 13" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M20 6V10.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 11V14C4 15.1046 7.58172 16 12 16" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 19L16 21L20 17" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const SyncCentralOfficeToCompanyIcon: FC<ISvgProps> = (props) => {
    return (
        <svg className={classNames(styles.svg, props.className)} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 7H8V17H3V7Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 7H21V17H16V7Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.5 10H5.51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.5 13H5.51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.5 10H18.51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.5 13H18.51" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 9H14" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M12.5 7.5L14 9L12.5 10.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M14 15H10" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.5 13.5L10 15L11.5 16.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
